import React from 'react'
import { NotificationType } from '../models/notifications.model'
import { DFClipboard, Notification, NotificationImportant, NotificationImportantRead, NotificationRead } from '@e3dc-react/icons'
import { makeStyles } from 'tss-react/mui'
import { Box } from '@mui/material'

const useStyles = makeStyles()(theme => ({
  messageUnread: {
    color: theme.palette.primary.main,
  },
}))

interface Props {
  notificationType: NotificationType
  readAt: Date | null
}

/**
 * Displays a symbol indicating the tpe of notification
 */
const NotificationTypeSymbol: React.VFC<Props> = ({ notificationType, readAt }) => {
  const { classes, cx } = useStyles()

  const getIcon = (): React.ReactElement => {
    if (notificationType === NotificationType.Survey) {
      return <DFClipboard className={cx({ [classes.messageUnread]: !readAt })} />
    } else if (notificationType === NotificationType.Mandatory) {
      if (readAt) {
        return <NotificationImportantRead />
      }
      return <NotificationImportant className={classes.messageUnread} />
    }

    if (readAt) {
      return <NotificationRead />
    }

    return <Notification className={classes.messageUnread} />
  }

  return <Box sx={{ mr: 2, display: 'flex' }}>{getIcon()}</Box>
}

export default NotificationTypeSymbol
